"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ArrowUp, Github, Linkedin, Twitter } from "lucide-react";
const agencyLinks = [{
  label: "Home",
  href: "/HomePage"
}, {
  label: "Our Studio",
  href: "#"
}, {
  label: "Contact",
  href: "#"
}];
const serviceLinks = [{
  label: "3D Printing",
  href: "#"
}, {
  label: "Laser Engraving",
  href: "#"
}, {
  label: "Digital Design",
  href: "#"
}, {
  label: "Custom Prototyping",
  href: "#"
}, {
  label: "Technical Consulting",
  href: "#"
}];
const resultsLinks = [{
  label: "Project Gallery",
  href: "#"
}, {
  label: "Client Reviews",
  href: "#"
}, {
  label: "Specifications",
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Terms of Use",
  href: "#"
}, {
  label: "Cookie Policy",
  href: "#"
}];
const socialLinks = [{
  icon: Twitter,
  label: "X",
  href: "#"
}, {
  icon: Linkedin,
  label: "LinkedIn",
  href: "#"
}, {
  icon: Github,
  label: "GitHub",
  href: "#"
}];
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <footer data-section-id="128682" id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 lg:px-24 font-sans text-xs tracking-normal">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex justify-center mb-20">
          <img src="https://known-swine.10web.cloud/wp-content/uploads/2026/03/Gemini_Generated_Image_vtkayivtkayivtka.png" alt="Quinn Studio - Precision in every layer" className="opacity-90 transition-opacity !w-[300px] !h-[175px] hover:opacity-100" />
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-secondary uppercase font-bold tracking-tight">
              Studio
            </h3>
            <ul className="flex flex-col gap-4">
              {agencyLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-ring transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-secondary uppercase font-bold tracking-tight">
              Capabilities
            </h3>
            <ul className="flex flex-col gap-4">
              {serviceLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-ring transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-secondary uppercase font-bold tracking-tight">
              Portfolio
            </h3>
            <ul className="flex flex-col gap-4">
              {resultsLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-ring transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-secondary uppercase font-bold tracking-tight">
              Compliance
            </h3>
            <ul className="flex flex-col gap-4">
              {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-ring transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-secondary/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-muted-foreground/60 text-center md:text-left font-mono text-[11px] uppercase tracking-wider">
            &copy; {new Date().getFullYear()} Quinn Studio. Precision in every layer.
          </div>

          <div className="flex items-center gap-6">
            <TooltipProvider>
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Tooltip key={social.label}>
                    <TooltipTrigger asChild data-index={i}>
                      <Link to={social.href} className="text-muted-foreground/60 hover:text-ring transition-colors duration-300" aria-label={social.label}>
                        <Icon className="size-4" strokeWidth={1} />
                      </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>{social.label}</p>
                    </TooltipContent>
                  </Tooltip>;
            })}
            </TooltipProvider>
          </div>

          <div className="flex items-center justify-center">
            <Button variant="ghost" size="icon" onClick={scrollToTop} className="group relative size-10 rounded-none border border-secondary/20 hover:border-ring/50 hover:bg-transparent transition-all duration-500" aria-label="Back to top">
              {}
              <div className="absolute inset-0 rounded-none border border-transparent group-hover:border-t-ring group-hover:animate-spin opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <ArrowUp className="size-4 text-muted-foreground group-hover:text-ring transition-colors duration-300" strokeWidth={1} />
            </Button>
          </div>
        </div>
      </div>
    </footer>;
}